

// Material Design 3 Elevation System (5 levels)
export const MD3_ELEVATION = {
  LEVEL_0: 'none',
  LEVEL_1: '0 1px 2px rgba(0,0,0,0.3), 0 1px 3px rgba(0,0,0,0.15)',
  LEVEL_2: '0 2px 6px rgba(0,0,0,0.2), 0 3px 8px rgba(0,0,0,0.12)',
  LEVEL_3: '0 4px 12px rgba(0,0,0,0.16), 0 6px 16px rgba(0,0,0,0.1)',
  LEVEL_4: '0 8px 24px rgba(0,0,0,0.15), 0 12px 32px rgba(0,0,0,0.08)',
};

// Material Design 3 Motion & Transitions
export const MD3_MOTION = {
  EASING: {
    STANDARD: 'cubic-bezier(0.4, 0.0, 0.2, 1)',
    DECELERATION: 'cubic-bezier(0.0, 0.0, 0.2, 1)',
    ACCELERATION: 'cubic-bezier(0.4, 0.0, 1, 1)',
    SHARP: 'cubic-bezier(0.4, 0.0, 0.6, 1)',
  },
  DURATION: {
    SIMPLE: 200,
    COMPLEX: 300,
    LARGE: 500,
  },
};

// Material Design 3 Component States
export const MD3_STATES = {
  HOVER: 'rgba(41, 50, 229, 0.08)',
  FOCUS: 'rgba(41, 50, 229, 0.12)',
  PRESSED: 'rgba(41, 50, 229, 0.12)',
  DRAGGED: 'rgba(41, 50, 229, 0.16)',
  DISABLED_OPACITY: 0.38,
  SELECTED: 'rgba(41, 50, 229, 0.08)',
};

// Material Design 3 Spacing System
export const MD3_SPACING = {
  XXS: '4px',
  XS: '8px',
  SM: '12px',
  MD: '16px',
  LG: '24px',
  XL: '32px',
  XXL: '48px',
  XXXL: '64px',
};

// Material Design 3 Border Radius
export const MD3_RADIUS = {
  XS: '4px',
  SM: '8px',
  MD: '12px',
  LG: '16px',
  XL: '20px',
  FULL: '9999px',
};

// Material Design 3 Z-Index System
export const MD3_Z_INDEX = {
  DRAWER: 1200,
  APP_BAR: 1100,
  MODAL_BACKDROP: 1300,
  MODAL: 1400,
  SNACKBAR: 1500,
  TOOLTIP: 1600,
  FAB: 1050,
};

// Material Design 3 Breakpoints
export const MD3_BREAKPOINTS = {
  XS: 0,
  SM: 600,
  MD: 900,
  LG: 1200,
  XL: 1536,
};

// Material Design 3 Typography Weights
export const MD3_FONT_WEIGHT = {
  LIGHT: 300,
  REGULAR: 400,
  MEDIUM: 500,
  BOLD: 700,
};

// Material Design 3 Focus Outline
export const MD3_FOCUS_OUTLINE = {
  WIDTH: '2px',
  STYLE: 'solid',
  COLOR: '#2932E5',
  OFFSET: '2px',
};

// Material Design 3 Table Density
export const MD3_TABLE_DENSITY = {
  COMFORTABLE: {
    HEIGHT: 56,
    PADDING: '16px',
  },
  COZY: {
    HEIGHT: 48,
    PADDING: '12px',
  },
  COMPACT: {
    HEIGHT: 40,
    PADDING: '8px',
  },
};

// WCAG 2.1 AA Colors
export const MD3_WCAG_COLORS = {
  TEXT_ON_LIGHT: '#4A5565',
  TEXT_ON_DARK: '#FFFFFF',
  LINK: '#1A73E8',
  ERROR: '#B3261E',
  SUCCESS: '#34A853',
  WARNING: '#F4B400',
  INFO: '#1A73E8',
};

// Keyboard Shortcuts
export const MD3_KEYBOARD_SHORTCUTS = {
  CLOSE_DIALOG: 'Escape',
  CONFIRM: 'Enter',
  SELECT_ALL: 'Control+A',
  DESELECT_ALL: 'Escape',
  DELETE: 'Delete',
  SEARCH: 'Control+K',
  NAVIGATE_NEXT: 'ArrowRight',
  NAVIGATE_PREV: 'ArrowLeft',
  PAGE_DOWN: 'PageDown',
  PAGE_UP: 'PageUp',
  ZOOM_IN: '+',
  ZOOM_OUT: '-',
};

// Snackbar/Toast Configuration
export const MD3_SNACKBAR = {
  POSITION: {
    DESKTOP: 'bottom-left',
    MOBILE: 'bottom-center',
  },
  DURATION: {
    SHORT: 4000,
    LONG: 10000,
  },
  MAX_WIDTH: '600px',
};

// Loading State Config
export const MD3_LOADING = {
  SKELETON_ANIMATION: 'wave',
  SPINNER_SIZE: {
    SMALL: 24,
    MEDIUM: 40,
    LARGE: 56,
  },
  DELAY_BEFORE_SHOWING: 200,
};

// Empty State Config
export const MD3_EMPTY_STATE = {
  ICON_SIZE: 64,
  MAX_WIDTH: '400px',
};

// Accessible Focus Style
export const getAccessibleFocusStyle = () => ({
  outline: `${MD3_FOCUS_OUTLINE.WIDTH} ${MD3_FOCUS_OUTLINE.STYLE} ${MD3_FOCUS_OUTLINE.COLOR}`,
  outlineOffset: MD3_FOCUS_OUTLINE.OFFSET,
});

// Hover Effect
export const getMD3HoverEffect = (backgroundColor = MD3_STATES.HOVER) => ({
  transition: `background-color ${MD3_MOTION.DURATION.SIMPLE}ms ${MD3_MOTION.EASING.STANDARD}`,
  '&:hover': {
    backgroundColor,
  },
});

// Press Effect
export const getMD3PressEffect = () => ({
  transition: `transform ${MD3_MOTION.DURATION.SIMPLE}ms ${MD3_MOTION.EASING.STANDARD}`,
  '&:active': {
    transform: 'scale(0.98)',
  },
});
